import {Pipe, PipeTransform} from "@angular/core";
//import { TranslateService } from '@ngx-translate/core';
import { IAddress } from '../services/address.service';
import { TranslationService } from "../services/translation.service";

@Pipe({
    name: 'formatAddress',
    standalone: false
})
export class FormatAddressPipe implements PipeTransform {

  constructor(
    //private translationService: TranslateService,
    private translationService: TranslationService
  ) {}

  transform(address: IAddress) : string {
    if (address == null)
        return '';

    /*if (address.streetDirection != undefined && address.streetDirection != '') {
      return `${address.streetNumber} ${address.street} ${address.streetDirection}, ${address.city}`;
    }

    return `${address.streetNumber} ${address.street}, ${address.city}`;*/

 
    if (address.streetDirection != undefined && address.streetDirection != '') {
      if (this.translationService.getLanguage().toLocaleLowerCase() == 'en') {
        return `${address.streetNumber} ${address.street} ${address.streetDirection} ${address.streetType}, ${address.city}`;
      } else if (this.translationService.getLanguage().toLocaleLowerCase() == 'fr') {
        return `${address.streetNumber} ${address.streetType} ${address.street} ${address.streetDirection}, ${address.city}`;
      }      
    }

    if (this.translationService.getLanguage().toLocaleLowerCase() == 'en') {
      return `${address.streetNumber} ${address.street} ${address.streetType}, ${address.city}`;
    } else if (this.translationService.getLanguage().toLocaleLowerCase() == 'fr') {
      return `${address.streetNumber} ${address.streetType} ${address.street}, ${address.city}`;
    }
    

  }
}